<div class="multi-select" (mouseleave)="showDropDown = false" [ngClass]="{'active': showDropDown}" (focusout)="outFocus($event, true)" >
    <input  type="text" autocomplete="off" class="form-control drop-toggle btn flat" [disabled]="isDisabled"
    [(ngModel)]="selectedValue" (change)="change()" placeholder="{{trans.instant('STR_CITY_PLACEHOLDER')}}"
    (keydown)="onKeyDownEvent($event)" [ngClass]="{'active': showDropDown, 'error-border': isError && util.isNullOrEmpty(selectedValue)}"
    (focus)="focus($event , true)" (click)="focus($event , true)"
    [maxlength]="maxLength" [id]="idInp" [class]="inpClss">
    <div class="drop-show scrollbar" [ngClass]="{'scroll-box': lstItem.length >=10, 'active': showDropDown, 'fadeShow': fadeLst, 'top': placementTop}">
        <div *ngFor="let it of lstItem; index as i">
            <button (click)="selected(it)" [title]="!util.isNullOrEmpty(it.Address) ? it.Address : ''" class="app-postal-code text-no-full" (focus)="focus($event , true)" (focusout)="outFocus($event, false)" (keydown)="onActionEvent($event, it)" [ngClass]="{'active': it.active, 'focus': it.focus}">
                {{it.Address}}
            </button>
        </div>
    </div>
</div>
<span *ngIf="isError && util.isNullOrEmpty(selectedValue)" class="text-error mb-2">
    {{util.stringFormat([trans.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED'),
    trans.instant('STR_ADDRESS1')])}}
</span>